export interface Service {
    id: string;
    icon: string;
    label: string;
    price: string;
    desc: string;
    content?: string;
    color?: string;
    bg?: string;
    image?: string;
}

export const services: Service[] = [
    {
        id: 'wellness',
        icon: 'medical_services',
        label: "Wellness Exams",
        price: "$50",
        desc: "Routine physicals to keep your pet healthy and catch issues early.",
        content: `
            <h3>Comprehensive Health Assessments</h3>
            <p>Our wellness exams are the foundation of your pet's long-term health. We recommend a full checkup at least once a year for adult pets and twice a year for seniors.</p>
            <ul>
                <li>Complete physical examination from nose to tail.</li>
                <li>Weight and nutritional assessment.</li>
                <li>Dental health check.</li>
                <li>Early screening for common age-related conditions.</li>
            </ul>
            <p>During these visits, we take the time to answer all your questions about behavior, diet, and general care.</p>
        `,
        color: "text-blue-500",
        bg: "bg-blue-50 dark:bg-blue-900/20",
        image: "https://images.unsplash.com/photo-1628009368231-7bb7cfcb0def?auto=format&fit=crop&w=1200&q=80"
    },
    {
        id: 'vaccines',
        icon: 'vaccines',
        label: "Vaccinations",
        price: "$45",
        desc: "Essential shots to protect your furry friend from common diseases.",
        content: `
            <h3>Tailored Protection for Your Pet</h3>
            <p>Vaccines are critical in preventing life-threatening diseases. We develop a core and lifestyle-based vaccination schedule specific to your pet's needs.</p>
            <blockquote>"Prevention is the best medicine. Keeping up with vaccinations saves lives and reduces long-term healthcare costs."</blockquote>
            <p>We provide protection against Rabies, Parvovirus, Distemper, Feline Leukemia, and more. Our team monitors for any reactions to ensure the safest experience possible.</p>
        `,
        color: "text-primary",
        bg: "bg-primary-50 dark:bg-primary/20",
        image: "https://images.unsplash.com/photo-1576091160550-217359f4ecf8?auto=format&fit=crop&w=1200&q=80"
    },
    {
        id: 'grooming',
        icon: 'content_cut',
        label: "Grooming Spa",
        price: "$60",
        desc: "Full-service grooming to make your pet look and feel their best.",
        content: `
            <h3>A Relaxing Spa Experience</h3>
            <p>Grooming isn't just about looking good—it's essential for hygiene and skin health. Our professional groomers handle pets with care and patience.</p>
            <p>Our spa packages include:</p>
            <ul>
                <li>Breath-freshening oral care.</li>
                <li>Deep-cleaning bubble baths with organic shampoos.</li>
                <li>Precision nail trimming and ear cleaning.</li>
                <li>Breed-specific styling and de-shedding treatments.</li>
            </ul>
        `,
        color: "text-pink-500",
        bg: "bg-pink-50 dark:bg-pink-900/20",
        image: "https://images.unsplash.com/photo-1516734212186-a967f81ad0d7?auto=format&fit=crop&w=1200&q=80"
    },
    {
        id: 'emergency',
        icon: 'emergency',
        label: "Emergency Care",
        price: "$120",
        desc: "Urgent care services for when the unexpected happens.",
        content: `
            <h3>When Every Second Counts</h3>
            <p>Our clinic is equipped to handle critical emergencies 24/7. From accidents to sudden illnesses, our trauma team is always on standby.</p>
            <p>We provide advanced diagnostics including digital X-rays and an in-house laboratory for rapid results. Our ICU offers oxygen therapy and continuous monitoring for critical patients.</p>
            <div class="bg-red-50 dark:bg-red-900/10 p-4 rounded-xl border border-red-100 dark:border-red-900/30">
                <strong>Emergency Contact:</strong> (555) 911-PETS — Call immediately if you suspect an emergency.
            </div>
        `,
        color: "text-orange-500",
        bg: "bg-orange-50 dark:bg-orange-900/20",
        image: "https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?auto=format&fit=crop&w=1200&q=80"
    },
];
